import React from "react";
import {
  INTERACTIVE_TAB_INDEX,
  NON_INTERACTIVE_TAB_INDEX,
  BADGE_COLOR_CLASSES,
} from "./constants";

const BadgeComponent = ({ text, color = "blue", clickable = false, onClick = null }) => {

  const baseClasses = "px-2 py-1 text-xs rounded-md border flex ";
  const colorClass = BADGE_COLOR_CLASSES[color] || BADGE_COLOR_CLASSES.blue;
  const cursorClass = clickable && onClick ? "cursor-pointer hover:opacity-80" : "";
  const tabIndex = clickable && onClick ? INTERACTIVE_TAB_INDEX : NON_INTERACTIVE_TAB_INDEX;

  return (
    <span
      className={`${baseClasses} ${colorClass} ${cursorClass}`}
      onClick={clickable && onClick ? onClick : undefined}
      role={clickable && onClick ? "button" : "status"}
      tabIndex={tabIndex}
      onKeyDown={clickable && onClick ? (e) => e.key === "Enter" && onClick() : undefined}
    >
      {text}
    </span>
  );
};

export default BadgeComponent;
